export default "__VITE_ASSET__DI_nFwBX__"